import { render, staticRenderFns } from "./SzervezetValaszto.vue?vue&type=template&id=3d565964&"
import script from "./SzervezetValaszto.vue?vue&type=script&lang=js&"
export * from "./SzervezetValaszto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports